import { Chip } from '@enterprise-ui/canvas-ui-react';
import React from 'react';

function defaultChipRenderer(value, onRequestDelete, disabled, id) {
  var chipHeight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'dense';
  return /*#__PURE__*/React.createElement(Chip, {
    className: disabled ? 'isDisabled' : null,
    size: chipHeight,
    "data-testid": "chip-".concat(id),
    disabled: disabled,
    id: id,
    onRequestDelete: onRequestDelete
  }, value.label);
}

export { defaultChipRenderer as default };
